import * as React from "react";
import { HeaderActionsItem } from "./item.mjs";
const HeaderActions = (props) => {
  const { checkIfDropdownShouldBeVisible, dropdownContainer, dropdownOffsetY, items, nav, onActionClick, sso } = props;
  const BEM = () => {
    const classArray = ["header__actions"];
    if (sso == null ? void 0 : sso.isLoggedIn) {
      classArray.push("is-logged-in");
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, /* @__PURE__ */ React.createElement("ul", { className: "header__actions-list" }, items.map((item) => {
    var _a, _b;
    const handleActionClick = (event) => {
      event.preventDefault();
      onActionClick(item.id);
      if (item.onClick) {
        item.onClick(event);
      }
    };
    const dropdownContent = (_a = item.dropdownContent) != null ? _a : item.id === "nav" ? nav.dropdownContent : void 0;
    const dropdownPadding = (_b = item.dropdownPadding) != null ? _b : item.id === "nav" ? nav.dropdownPadding : void 0;
    return /* @__PURE__ */ React.createElement(
      HeaderActionsItem,
      {
        ...item,
        location: props.location,
        dropdownContent,
        dropdownContentRef: item.id === "nav" ? nav.dropdownRef : void 0,
        dropdownContainer,
        dropdownPadding,
        dropdownOffsetY,
        isCurrent: checkIfDropdownShouldBeVisible == null ? void 0 : checkIfDropdownShouldBeVisible(item.id),
        onClick: item.id === "search" ? handleActionClick : item.onClick,
        onToggle: () => onActionClick(item.id),
        isPlaceholder: item.id === "sso" && sso && !sso.isSsoLoaded,
        key: item.id,
        asModal: true
      }
    );
  })));
};
export {
  HeaderActions
};
